var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center mt-16"},[_c('h2',{staticStyle:{"color":"#AF0808"}},[_vm._v("Not allowed!")])])
}]

export { render, staticRenderFns }